<template>
  <v-container class="background fullwith pa-0">
    <v-layout
      style="
      position: absolute !important;
      top: 150px !important;
      z-index: +1 !important;
      width: 100% !important;
      text-align: center !important;
      display: block !important;
      margin-left: auto !important;
      margin-right: auto !important;
      "
      class="white--text"
    >
      <img src="@/assets/logo_2.png" @click="scrollBotom()" alt="Geospace: Geoscience Research and solutions" class="hidden-md-and-up" height="90">
      <img src="@/assets/logo_2.png" @click="scrollBotom()" alt="Geospace: Geoscience Research and solutions" class="hidden-sm-and-down" height="130">
    </v-layout>

          <v-carousel
          id="top"
              ma-0
              column
              height="100"
              align-center
              justify-center
              hide-delimiters>
              <v-carousel-item

                v-for="(item,i) in items"
                :key="i"
                :src="item.src"
              >
            </v-carousel-item>
            </v-carousel>

            <v-parallax v-if="false" id="top" :src="require('@/assets/cern_6.jpg')" height="650">
              <v-layout
                column
                align-center
                justify-center
                class="white--text"
              >
                <img src="@/assets/logo_2.png" @click="scrollBotom()" alt="Geospace: Geoscience Research and solutions" class="hidden-md-and-up" height="90">
                <img src="@/assets/logo_2.png" @click="scrollBotom()" alt="Geospace: Geoscience Research and solutions" class="hidden-sm-and-down" height="130">
<!--                <h1 v-if="this.language == 'EN'" style="color: black"class="mb-2 font-weight-medium text-xs-center"><i>Instrumentation and technology</i></h1>
                <h1 v-if="this.language == 'PT'" style="color: black" class="mb-2 font-weight-medium text-xs-center"><i>Instrumentação e tecnologia</i></h1>
                <div v-if="this.language == 'EN'"  class="subheading font-italic mb-3 text-xs-center">Magnetism and High Technology Solutions</div>
                <div v-if="this.language == 'PT'"  class="subheading font-italic mb-3 text-xs-center">Soluções em Magnetismo e Alta Tecnologia</div>
                <v-btn
                  class="deep-orange accent-4 mt-5"
                  dark
                  round
                >
                  Soluções
                </v-btn>
-->
              </v-layout>
            </v-parallax>

          <section v-if="true" >
            <v-layout
              column
              wrap
              class="my-5"
              align-center
            >
              <v-flex v-if="false" xs12 sm4 class="my-3">
                <div class="text-xs-center font-weight-bold font-italic">
                  <h2 class="headline font-weight-black">Conte conosco para alcançar os melhores resultados!</h2>
                  <span class="subheading">
                    Soluções customizadas para seu negócio.
                  </span>
                </div>
              </v-flex>
              <v-flex xs12>
                <v-container grid-list-xl>
                  <v-layout row wrap align-center>
                    <v-flex v-if="false" xs12 md4> <!-- id="solucoes" -->
                      <v-card class="elevation-5s">
                        <v-card-text class="text-xs-center">
                          <v-icon x-large class="blue--text text--lighten-2">school</v-icon>
                        </v-card-text>
                        <v-card-title primary-title class="layout justify-center">
                          <div class="headline text-xs-center">Pesquisa & Desenvolvimento</div>
                        </v-card-title>
                        <v-card-text class="text-xs-center">
                          Investir em Pesquisa e Desenvolvimento é o elemento chave para tornar sua empresa competitiva em relação a um mercado de constante mudanças.
                          Possuímos a experiência necessária para o desenvolvimento de tecnologias de alto desempenho.
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex v-if="false"  xs12 md4>
                      <v-card class="elevation-5 text-xs-center">
                        <v-card-text class="text-xs-center">
                          <v-icon x-large class="blue--text text--lighten-2">flash_on</v-icon>
                        </v-card-text>
                        <v-card-title primary-title class="layout justify-center">
                          <div class="headline">Nossos produtos</div>
                        </v-card-title>
                        <v-card-text class="text-xs-center">
                          Desenvolvemos equipamentos de alta tecnologia em magnetismo para áreas de instrumentação, ressonância e aceleradores de partículas.
                        </v-card-text>
                        <v-btn
                          class="blue-grey ma-3"
                          dark
                          round
                          small
                          @click="gotoscroll('produtos')"
                        >
                          Conheça nossos produtos
                        </v-btn>
                      </v-card>
                    </v-flex>
                    <v-flex v-if="false" xs12 md4>
                      <v-card class="elevation-5">
                        <v-card-text class="text-xs-center">
                          <v-icon x-large class="blue--text text--lighten-2">build</v-icon>
                        </v-card-text>
                        <v-card-title primary-title class="layout justify-center">
                          <div class="headline text-xs-center">Assessoria & Consultoria</div>
                        </v-card-title>
                        <v-card-text class="text-xs-center">
                          Aumente o desempenho de sua empresa através de nossa experiência de 25 anos em soluções de alta tecnologia.
                          Buscamos de soluções, visando maior eficácia possível e menor custo. Atuamos <i>in company</i> e adequamos nosso quadro de pessoas e soluções conforme sua necessidade.
                        </v-card-text>
                      </v-card>
                    </v-flex>

                    <v-flex xs12 v-if="false" class="mt-4">
                      <div class="text-xs-center font-weight-bold font-italic">
                        <h2 id="produtos" class="headline font-weight-black">Nossos produtos</h2>
                      </div>
                    </v-flex>


                    <v-dialog v-model="openLoginFunc" scrollable max-width="500px">
                      <v-card>
                        <v-card-title class="headline font-italic">
                          <span v-if="this.language == 'EN'">Log In</span>
                          <span v-if="this.language == 'PT'">Entrar</span>
                          <v-spacer></v-spacer>
                          <img src="@/assets/logo_1.svg" height="30">
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text style="height: 245px;">
                          <v-layout row wrap> <!-- align-center -->
                            <v-flex v-if="this.language == 'PT'" xs12 >
                             <v-text-field
                             v-model="user"
                             :rules="nameRules"
                             label="Usuário"
                             @keyup.native.enter="openLoginFuncx(true)"
                             required
                             outline
                             ></v-text-field>
                           </v-flex>
                            <v-flex v-if="this.language == 'PT'" xs12>
                                <v-text-field
                                  v-model="password"
                                  :append-icon="show1 ? 'visibility_off' : 'visibility'"
                                  :rules="[rules.requiredPT, rules.minPT]"
                                  :type="show1 ? 'text' : 'password'"
                                  name="input-10-1"
                                  :counter="8"
                                  label="Senha"
                                  outline
                                  @keyup.native.enter="openLoginFuncx(true)"
                                  @click:append="show1 = !show1"
                                ></v-text-field>
                              </v-flex>

                            <v-flex v-if="this.language == 'EN'" xs12 >
                             <v-text-field
                               v-model="user"
                               :rules="nameRules"
                               @keyup.native.enter="openLoginFuncx(true)"
                               label="User"
                               required
                               outline
                             ></v-text-field>
                           </v-flex>
                            <v-flex v-if="this.language == 'EN'" xs12>
                                <v-text-field
                                  v-model="password"
                                  :append-icon="show1 ? 'visibility_off' : 'visibility'"
                                  :rules="[rules.required, rules.min]"
                                  :type="show1 ? 'text' : 'password'"
                                  name="input-10-1"
                                  label="Password"
                                  outline
                                  required
                                  :counter="8"
                                  @keyup.native.enter="openLoginFuncx(true)"
                                  @click:append="show1 = !show1"
                                ></v-text-field>
                              </v-flex>
                              <v-flex v-if="this.progressBarShow" xs12>
                                <v-progress-linear :indeterminate="true"></v-progress-linear>
                              </v-flex>
                              <v-flex class="text-xs-center" v-if="this.loginErrorMsg" xs12>
                                <span style="color: red" v-if="this.language == 'EN'">No user or wrong password!</span>
                                <span style="color: red" v-if="this.language == 'PT'">Usuário não encontrado ou senha incorreta!</span>
                              </v-flex>

                          </v-layout >



                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                           <v-spacer></v-spacer>
                          <v-btn v-if="this.language == 'EN'" color="blue darken-1" flat @click.native="openLoginFuncx(false)">Cancel</v-btn>
                          <v-btn v-if="this.language == 'PT'" color="blue darken-1" flat @click.native="openLoginFuncx(false)">Cancelar</v-btn>
                          <v-btn v-if="this.language == 'EN'" color="blue darken-1" dark @click.native="openLoginFuncx(true)">Login</v-btn>
                          <v-btn v-if="this.language == 'PT'" color="blue darken-1" dark  @click.native="openLoginFuncx(true)">Entrar</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>


                    <v-flex id="solucoes"  xs12 sm4>
                      <v-card class="cardmin elevation-5 text-xs-center  "> <!-- CLASS: pointer @click.native="dipolo_1 = true"-->
                        <v-card-title primary-title class="layout justify-center">
                          <div v-if="this.language == 'EN'" class="title text-xs-center">Assistance & Consultancy</div>
                          <div v-if="this.language == 'PT'" class="title text-xs-center">Assessoria & Consultoria</div>
                        </v-card-title>
                        <img src="@/assets/consulting.png" class="mt-2" height="150">
                        <v-card-text v-if="this.language == 'EN'" class="text-xs-center">
                          We look for technical solutions aiming for effectiveness and lower cost. We operate <i> in company </i> and we adapt our people and solutions to suit your needs.
                          </v-card-text>
                        <v-card-text v-if="this.language == 'PT'" class="text-xs-center">
                          Buscamos soluções técnicas visando maior eficácia e menor custo. Atuamos <i>in company</i> e adequamos nosso quadro de pessoas e soluções conforme sua necessidade.
                        </v-card-text>
                      </v-card>
                    </v-flex>

                    <v-flex xs12 sm4>
                      <v-card class="cardmin elevation-5 text-xs-center  "> <!-- CLASS: pointer @click.native="dipolo_1 = true"-->
                        <v-card-title primary-title class="layout justify-center">
                          <div v-if="this.language == 'EN'" class="title text-xs-center">Hardware & Software</div>
                          <div v-if="this.language == 'PT'" class="title text-xs-center">Hardware & Software</div>
                        </v-card-title>
                        <img src="@/assets/sofware2.png" class="mt-2" height="150">
                        <v-card-text v-if="this.language == 'EN'" class="text-xs-center">
                          We develop innovative monitoring and control technologies. Our know-how enables the creation of integrated and more reliable hardware and software.
                          </v-card-text>
                        <v-card-text v-if="this.language == 'PT'" class="text-xs-center">
                          Desenvolvemos tecnologias inovadoras de monitoramento e controle. <br>Nosso <i>know-how</i> possibilita a criação de hardware e software integrados e com maior confiabilidade.
                        </v-card-text>
                      </v-card>
                    </v-flex>

                    <v-flex xs12 sm4>
                      <v-card class="cardmin elevation-5 text-xs-center  "> <!-- CLASS: pointer @click.native="dipolo_1 = true"-->
                        <v-card-title primary-title class="layout justify-center">
                          <div v-if="this.language == 'EN'" class="title text-xs-center">Web Application Development</div>
                          <div v-if="this.language == 'PT'" class="title text-xs-center">Desenvolvimento de Aplicações Web</div>
                        </v-card-title>
                        <img src="@/assets/telemetry.png" class="mt-2" height="150">
                        <v-card-text v-if="this.language == 'EN'" class="text-xs-center">
                          We develop Web Applications for a wide variety of markets, from a simple education system to complex telemetry and remote control systems.
                          </v-card-text>
                        <v-card-text v-if="this.language == 'PT'" class="text-xs-center">
                          Desenvolvemos Aplicações Web para uma grande variedade de mercados, criamos desde um simples sistema educacional até sistemas complexos para telemetria e controle remoto.
                        </v-card-text>
                      </v-card>
                    </v-flex>




                    <v-flex v-if="false" xs12 md3>
                      <v-card class="cardmin elevation-5 text-xs-center  ">
                        <v-card-title primary-title class="layout justify-center">
                          <div v-if="this.language == 'EN'" class="title text-xs-center">Audit & Inspection</div>
                          <div v-if="this.language == 'PT'" class="title text-xs-center">Auditorias & Inspeções</div>
                        </v-card-title>
                        <img src="@/assets/inspection.png" class="mt-2" height="150">
                        <v-card-text v-if="this.language == 'EN'" class="text-xs-center">
                          We look for solutions aiming for greater effectiveness and lower cost. We operate <i> in company </i> and we adapt our people and solutions to suit your needs.
                          </v-card-text>
                        <v-card-text v-if="this.language == 'PT'" class="text-xs-center">
                          Buscamos de soluções, visando maior eficácia possível e menor custo. Atuamos <i>in company</i> e adequamos nosso quadro de pessoas e soluções conforme sua necessidade.
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex v-if="false" xs12 md3>
                      <v-card class="cardmin elevation-5 text-xs-center  ">
                        <v-card-title primary-title class="layout justify-center">
                          <div v-if="this.language == 'EN'" class="title text-xs-center">Training Courses</div>
                          <div v-if="this.language == 'PT'" class="title text-xs-center">Cursos de formação</div>
                        </v-card-title>
                        <img src="@/assets/training.png" class="mt-2" height="150">
                        <v-card-text v-if="this.language == 'EN'" class="text-xs-center">
                          We look for solutions aiming for greater effectiveness and lower cost. We operate <i> in company </i> and we adapt our people and solutions to suit your needs.
                          </v-card-text>
                        <v-card-text v-if="this.language == 'PT'" class="text-xs-center">
                          Buscamos de soluções, visando maior eficácia possível e menor custo. Atuamos <i>in company</i> e adequamos nosso quadro de pessoas e soluções conforme sua necessidade.
                        </v-card-text>
                      </v-card>
                    </v-flex>

                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </section>

          <section id="quem_somos">
            <v-parallax :src="require('@/assets/cern_2.jpg')" height="480">
              <v-layout row wrap align-center >

                <v-flex xs12 md8 offset-md2>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-xs-center">
                      <div v-if="this.language == 'EN'" class="display-2 font-weight-bold white--text mb-3 text-xs-center">Who</div>
                      <div v-if="this.language == 'PT'" class="display-2 font-weight-bold white--text mb-3 text-xs-center">Quem somos</div>
                    </v-card-text>
                    <v-card-text v-if="this.language == 'EN'" class="subheading white--text text-xs-center">
                      We are a company focused on the development of technology projects, focusing on solutions for Civil Engineering. We work in the development of structural, geotechnical and geo-environmental instrumentation, using the most modern technologies in our projects. We apply concepts and algorithms from the Internet of Things (IoT), Artificil Intelligence - AI and Modern Web Systems in real time.
                    </v-card-text>
                    <v-card-text v-if="this.language == 'PT'" class="subheading white--text text-xs-center">
                      Somos um empresa focada no desenvolvimento projetos de tecnologia, com enfase em soluções para área de Engenharia Civil. Atuamos no desenvolvimento de instrumentação estrutural, geotécnica e geoambiental, utilizando as mais modernas tecnologias em nossos projetos. Aplicamos conceitos e algoritmos da área de Internet das Coisas (IoT), Inteligência Artificil - IA e de Sistemas Modernos de Web em tempo real.                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex text-xs-center v-if="false" xs12 md8 offset-md2>
                      <div v-if="this.language == 'EN'" class="display-1 font-weight-bold white--text mb-4 text-xs-center">Technical Responsible</div>
                      <div v-if="this.language == 'PT'" class="display-1 font-weight-bold white--text mb-4 text-xs-center">Responsável Técnico</div>
                      <span v-if="this.language == 'EN'" class="headline pt-5 mt-2 white--text"><b>PhD.  Giancarlo Tosin</b><br><br></span>
                      <span v-if="this.language == 'PT'" class="headline pt-5 mt-2 white--text"><b>Dr.  Giancarlo Tosin</b><br><br></span>
                      <v-btn v-if="this.language == 'EN'"
                          class="primary mb-3"
                          dark
                          round
                          small
                          target="_blank"
                          href="http://lattes.cnpq.br/4969733418058821"
                        >
                          Lattes Curriculum
                        </v-btn>
                      <v-btn v-if="this.language == 'PT'"
                          class="primary mb-3"
                          dark
                          round
                          small
                          target="_blank"
                          href="http://lattes.cnpq.br/4969733418058821"
                        >
                          Currículo Lattes
                        </v-btn>
                        <v-btn
                          class="primary mb-3"
                          dark
                          round
                          small
                          target="_blank"
                          href="https://www.linkedin.com/in/giancarlo-tosin-526580103/"
                        >
                          <i class="fab fa-linkedin"></i>&nbsp;&nbsp;LinkedIn
                        </v-btn>
                </v-flex>

              </v-layout>
            </v-parallax>
          </section>
          <section id="parceiros">
            <v-parallax :src="require('@/assets/partner_low.jpg')" height="320">
              <v-layout  row wrap align-center>

                <v-flex xs12>
                  <v-card class="elevation-0 transparent text-xs-center">
                    <v-card-text class="text-xs-center">
                      <div v-if="this.language == 'EN'" class="display-2 font-weight-bold blue-grey--text darken-3 mb-3 text-xs-center">Partners</div>
                      <div v-if="this.language == 'PT'" class="display-2 font-weight-bold blue-grey--text darken-3 mb-3 text-xs-center">Parceiros</div>
                    </v-card-text>
                    <!--<h1 onclick="window.open('http://www.fitinstrument.com', '_blank');" class="pointer mb-2 font-weight-medium text-xs-center">Fine Instrument Technology </h1>
                    <v-card-text v-if="this.language == 'EN'" class="subheading text-xs-center">
                      FIT is a company for NMR instrumentation. At the end of 2013 it began a cooperation which became a technical partnership in 2017. This partnership comprises the following items:
                      <br>- Magnets for NMR;
                      <br>- Accessories for NMR as probes and thermalized containers for the magnets;
                      <br>- Magnets for general applications in research;
                      <br>- Sub products derived from magnet projects.
                    </v-card-text>
                    <v-card-text v-if="this.language == 'PT'" class="subheading text-xs-center">
                      A Geo Instrumentos é uma empresa com mais de 30 anos de knowhow na área de instrumentác parceira da Geospace, focada na venda e desenvolvimento de soluções de instrumentação civil.
                    </v-card-text>-->
                  </v-card>
                </v-flex>
                <v-flex xs12 md3>
                  <v-card class="elevation-0 transparent text-xs-center">
                    <img src="@/assets/geoinstrumentos.png" alt="Geo Instrumentos" class="" height="70">
                  </v-card>
                </v-flex>
                <v-flex xs12 md3>
                  <v-card class="elevation-0 transparent text-xs-center">
                    <img src="@/assets/digitalocean.png" alt="Geo Instrumentos" class="" height="80">
                  </v-card>
                </v-flex>
                <v-flex xs12 md3>
                  <v-card class="elevation-0 transparent text-xs-center">
                    <img src="@/assets/ca_and_ma.png" alt="Geo Instrumentos" class="" height="80">
                  </v-card>
                </v-flex>
                <v-flex xs12 md3>
                  <v-card class="elevation-0 transparent text-xs-center">
                    <img src="@/assets/logo_black.svg" alt="Geo Instrumentos" class="" height="80">
                  </v-card>
                </v-flex>

              </v-layout>
            </v-parallax>
          </section>

          <section>
            <v-container grid-list-xl>
              <v-layout row wrap justify-center class="my-4">
                <v-flex v-if="false" sm12 md6>
                  <v-card class="elevation-5 blue-grey darken-2 pa-3">
                    <v-card-title primary-title class="layout justify-center">
                      <div v-if="this.language == 'EN'" class="display-1 font-weight-bold white--text mb-3 text-xs-center">Technical Responsible</div>
                      <div v-if="this.language == 'PT'" class="display-1 font-weight-bold white--text mb-3 text-xs-center">Responsável Técnico</div>
                    </v-card-title>
                    <v-layout row wrap justify-center mb-2>
                      <v-flex xs5 ma-0 pa-0  class="text-xs-center">
                        <img src="@/assets/tio_gian_foto.jpg" onclick="window.open('http://lattes.cnpq.br/4969733418058821', '_blank');" alt="Dr. Giancarlo Tosin" class="pointer elevation-5" height="205">
                        <br>
                        <span v-if="this.language == 'EN'" class="subheading pa-0 ma-0 white--text"><b>PhD.  Giancarlo Tosin</b><br><br></span>
                        <span v-if="this.language == 'PT'" class="subheading pa-0 ma-0 white--text"><b>Dr.  Giancarlo Tosin</b><br><br></span>
                      </v-flex>
                      <v-flex xs7 ma-0 pa-0 px-2>
                        <span class="body-2 white--text">Possui graduação e mestrado Física pela Universidade Federal do Rio Grande do Sul - URGS e doutorado em Engenharia Elétrica pela Universidade Estadual de Campinas - Unicamp e um pós-doutorado em Engenharia Elétrica pela COPPETEC-RJ.</span>
                        <br><v-btn
                          class="primary ma-3"
                          dark
                          round
                          small
                          target="_blank"
                          href="http://lattes.cnpq.br/4969733418058821"
                        >
                          Currículo Lattes
                        </v-btn>
                        <v-btn
                          class="primary ma-3"
                          dark
                          round
                          small
                          target="_blank"
                          href="https://www.linkedin.com/in/giancarlo-tosin-526580103/"
                        >
                          <i class="fab fa-linkedin"></i>&nbsp;&nbsp;LinkedIn
                        </v-btn>
                    </v-flex>
<!--                      <v-flex xs12 ma-0 pa-0  class="text-xs-center">
                        <span class="body-2">Atuou como físico pleno do Centro Nacional de Pesquisa em Energia e Materiais (CNPEM) durante 20 anos, pertencendo à equipe pioneira que construiu o Laboratório Nacional de Luz Síncrotron (LNLS), sendo responsável pelo grupo de Magnetos e Dispositivos de Inserção (grupo IMA).</span>
                    </v-flex>
-->
                  </v-layout>
                  </v-card>
                </v-flex>
                <v-flex sm12 md6>
                  <v-card style="border-radius: 20px" class="elevation-5 blue-grey darken-2 text-xs-center pa-3 white--text ">
                    <v-card-title id="contato" primary-title class="layout justify-center">
                      <div  v-if="this.language == 'EN'" class="display-1 font-weight-bold white--text mb-3 text-xs-center">Contact</div>
                      <div  v-if="this.language == 'PT'" class="display-1 font-weight-bold white--text mb-3 text-xs-center">Contato</div>
                    </v-card-title>
                    <v-layout row wrap justify-center>
                      <v-flex v-if="" xs12 sm12 md9 lg6 xl4>
                        <v-list-tile>
                          <v-list-tile-action>
                            <v-icon class="blue--text text--lighten-2">place</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title v-if="this.language == 'EN'"  class="white--text">São Carlos-SP, Brazil</v-list-tile-title>
                            <v-list-tile-title v-if="this.language == 'PT'"  class="white--text">São Carlos-SP, Brasil</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-action>
                            <v-icon class="blue--text text--lighten-2">email</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title class="white--text">contato@geo.space</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </section>

  </v-container>
</template>

<style >
.pointer {cursor: pointer;}
.sgt5{fill:#f0f0f0;stroke:none !important;}.sgt6,.sgt7,.sgt8,.sgt9{stroke-linecap:round;stroke-linejoin:round}.sgt6{fill:none;stroke-miterlimit:10;stroke:#d1d3d4 !important;}.sgt7,.sgt8,.sgt9{stroke:#c7c8ca}.sgt7{stroke-width:3;stroke-miterlimit:10;fill:#fff}.sgt8,.sgt9{fill:none}.sgt8{stroke-miterlimit:10;stroke-width:2}.sgt9{stroke-width:3}.sgt10{fill:#c7c8ca;stroke:none !important;}.sgt11{stroke:#c7c8ca !important;stroke-width:2}.sgt11,.sgt12,.sgt14,.sgt16,.sgt17{fill:none;stroke-linecap:round;stroke-linejoin:round}.sgt12{stroke-width:2;stroke-miterlimit:10;stroke:#bcbec0 !important;}.sgt14{stroke:#6d6e71 !important;}.sgt16,.sgt17{stroke:#c7c8ca !important;stroke-width:3;stroke-miterlimit:10}.sgt17{stroke:#6d6e71;stroke-width:2}
.sgt0{fill:#fff;stroke:none !important;}.sgt1{fill:none;stroke:#d1d3d4 !important;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.sgt2{fill:#0d47a1;stroke:none !important;}
.sgt0{fill:#fff;stroke:none !important;}.sgt1{fill:none;stroke:#d1d3d4 !important;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.sgt2{fill:#0d47a1;stroke:none !important;}.sgt3,.sgt4{fill:none;stroke:#0d47a1 !important;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.sgt4{stroke:#bcbec0 !important;stroke-miterlimit:10}.sgt6{fill:red}.sgt7{fill:none;stroke:#6d6e71!important;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}
.sgt0{fill:#fff;stroke:none !important;}.sgt1{fill:none;stroke:#d1d3d4 !important;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.sgt2{fill:#0d47a1;stroke:none !important;}.sgt3{fill:none;stroke:#0d47a1 !important;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}
</style>

<script>
import * as VueScrollTo  from 'vue-scrollto'
import { mapGetters, mapState } from 'vuex'
import { LANGUAGE, ENTRARLOGIN, ENTRAR_WINDOW } from '../../store/actions/navigation'

  export default {
    name: 'principal_novo',
    data () {
      return {
        progressBarShow: false,
        items: [
          {
            src: 'https://geo.space/cdn/cern_6.jpg'
          },
          {
            src: 'https://geo.space/cdn/banner2.jpg'
          },
          {
            src: 'https://geo.space/cdn/banner5.jpg'
          },
          {
            src: 'https://geo.space/cdn/banner6.jpg'
          }
        ],
        loginErrorMsg: false,
        snackbar: false,
        receber_novidades_email: false,
        dipolo_1: false,
        dipolo_1_1: false,
        dipolo_1_2: false,
        dipolo_2_1: false,
        dipolo_2: false,
        dipolo_3: false,
        dipolo_4: false,
        homogeneidade: false,
        dialogm1: 'false',
        openLogin: false,
        show1: false,
        valid: false,
        user: '',
              nameRules: [
                v => !!v || 'User is required',
                v => v.length <= 10 || 'User must be less than 10 characters'
              ],
        password: '',
          rules: {
            required: value => !!value || 'Required.',
            requiredPT: value => !!value || 'Requerido.',
            minPT: v => v.length >= 8 || 'Mín. 8 caracteres',
            min: v => v.length >= 8 || 'Min. 8 characters',
            emailMatch: () => ('The email and password you entered don\'t match')
          }
      }
    },
    methods: {
      gotoscroll: function (e) {
        if(e==='produtos'){
          VueScrollTo.scrollTo('#produtos', 1000,{offset: -90, cancelable: true})
        }
      },
      scrollBotom (){
        setTimeout(function(){
          VueScrollTo.scrollTo('#resultado', 500,{offset: -60, cancelable: true})
        },500)
      },
      button_test () {
        //***//_x_console.log('OI CAUE')
      },
      dadosDeProjeto () {
        //***//_x_console.log('dados De Projeto called');
        this.snackbar = true
      },
      recalques () {
        //***//_x_console.log('recalq called');
        //this.$store.dispatch(CLOSE_BUTTON_SHOW,{value: true, id: 5});
      },
      tensaoadm () {
        //***//_x_console.log('tensao adm called');
        this.snackbar = true
      },
      capacidadeDeCarga () {
        //***//_x_console.log('capacidade De Carga called');
        //this.$store.dispatch(CLOSE_BUTTON_SHOW,{value: true, id: 4});
      },
      openLoginFuncx: function (e) {
        var self = this;
        if(e==false){
          self.$store.dispatch(ENTRAR_WINDOW,false)
          self.user = '';
          self.password = '';
          self.progressBarShow = false;
          self.loginErrorMsg = false;
        }else{
          if(self.user!='' && self.password!=''){
            if(self.user=='Ober' || self.user=='ober'){
              if(self.password=='trialsin'){
                self.progressBarShow = true;
                setTimeout(function(){
                  self.$store.dispatch(ENTRAR_WINDOW,false);
                  self.progressBarShow = false;
                  setTimeout(function(){
                    window.open('https://geo.space/ober/?U2FsdGVkX18ZUVvShFSES21qHsQEqZXMxQ9zgHy', '_self');
                  },300)
                },1000)
              }else{
                self.loginErrorMsg = true;
                setTimeout(function(){
                  self.loginErrorMsg = false;
                },5000);
              }
            }else if(self.user=='Admin' || self.user=='admin'){
              if(self.password=='trialsin'){
                self.progressBarShow = true;
                setTimeout(function(){
                  self.$store.dispatch(ENTRAR_WINDOW,false);
                  self.progressBarShow = false;
                  setTimeout(function(){
                    window.open('https://geo.space/ober/?Z2fgFsdfxVkasd43ZUVvShFSES21qHsQEqZXMxQfdfwsdefgeggH1', '_self');
                  },300)
                },1000)
              }else{
                self.loginErrorMsg = true;
                setTimeout(function(){
                  self.loginErrorMsg = false;
                },5000);
              }
            }else{
              self.loginErrorMsg = true;
              setTimeout(function(){
                self.loginErrorMsg = false;
              },5000);
            }
            //window.open('http://geo.space/'+this.user+'/?user='+this.user+'&pass='+this.password, '_blank');

          }
        }
        //***//_x_console.log('capacidade De Carga called');
        //this.$store.dispatch(CLOSE_BUTTON_SHOW,{value: true, id: 4});
      }

    },
    computed: {
      ...mapState({
        language: state => state.navigation.language,
        loginWindows: state => state.navigation.loginWindow,
      }),
      openLoginFunc: {
        get(){
          return this.loginWindows
        },
        set(value){
          this.$store.dispatch(ENTRAR_WINDOW,value)
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/inicial/index.vue